var emailAddressArray = [
  'brian',
  '@',
  'brianknapp',
  'developer',
  '.',
  'com'
];

var emailAddress = emailAddressArray.join('');

$('.email-link').html(emailAddress);
